module.exports = __webpack_public_path__ + "img/racecourse-vaal-turf-classic-2400.f92e6637.svg";